var angular = require('angular');
import licenseModule from '../../license.module';

export default licenseModule.component('licenseAppspaceId', {
    template: require('./licenseAppspaceId.component.html'),
    controller: [
        'asLoadingMask',
        'entitlementConstants',
        'usageTypeConstants',
        'doughnutService',
        'textResources',
        licenseAppspaceIdComponent
    ],
    bindToController: true,
    bindings: {
        appspaceIdSummary: '<'
    }
});

function licenseAppspaceIdComponent(
    asLoadingMask,
    entitlementConstants,
    usageTypeConstants,
    doughnutService,
    textResources
) {
    var vm = this;
    vm.$onInit = activate;
    vm.$onChanges = change;
    asLoadingMask.show();

    function renderDonuts(data) {
        data = angular.copy(data);
        if (vm.appspaceIdSummary != null) {
            var deviceIdUsage = data.subscription.deviceId.usage;
            var deviceIdTotal = data.subscription.deviceId.total;
            var premiumUserIdUsage = data.subscription.premiumUserId.usage;
            var premiumUserIdTotal = data.subscription.premiumUserId.total;

            // if subscription expired, the perpetual usage & total will be used as the new data for the chart
            if (
                data.subscription.deviceId.total <= 0 ||
                data.subscription.premiumUserId.total <= 0
            ) {
                deviceIdUsage = data.perpetual.deviceId.usage;
                deviceIdTotal = data.perpetual.deviceId.total;
                premiumUserIdUsage = data.perpetual.premiumUserId.usage;
                premiumUserIdTotal = data.perpetual.premiumUserId.total;
            }

            // Device ID Chart
            var deviceColor = doughnutService.getDoughnutColor(
                data.device.alertLevel,
                usageTypeConstants.device
            );
            var chart1 = {
                planName: data.plan,
                usage: deviceIdUsage,
                total: deviceIdTotal,
                unit: '',
                cals: data.perpetual.deviceId.total,
                color: deviceColor,
                chartTitle: entitlementConstants.devices,
                balanceMessage: vm.balanceMessage,
                showTooltips: true,
                endDate: data.endDate,
                showStaticUsage: data.hasStaticAllocation,
                hasOlderVersion: data.hasOlderVersion,
                actualUsage: data.usage.deviceId.usage,
                usageUnknownMessage: textResources.usageDeviceUnknown
            };
            vm.chart1 = chart1;

            // Premium User Id Chart
            var premiumUserColor = doughnutService.getDoughnutColor(
                data.platformUser.alertLevel,
                usageTypeConstants.platformUser
            );
            var chart2 = {
                planName: data.plan,
                usage: premiumUserIdUsage,
                total: premiumUserIdTotal,
                unit: '',
                cals: data.perpetual.premiumUserId.total,
                color: premiumUserColor,
                chartTitle: entitlementConstants.platformUsers,
                balanceMessage: vm.balanceMessage,
                showTooltips: true,
                endDate: data.endDate,
                showStaticUsage: data.hasStaticAllocation,
                hasOlderVersion: data.hasOlderVersion,
                actualUsage: data.usage.premiumUserId.usage,
                usageUnknownMessage: textResources.usagePlatformUserUnknown
            };
            vm.chart2 = chart2;
        }
    }

    function activate() {
        vm.theTitle = entitlementConstants.globalUsage;
    }

    function change(changeObj) {
        if (
            changeObj.appspaceIdSummary.currentValue &&
            changeObj.appspaceIdSummary.currentValue != null
        ) {
            renderDonuts(vm.appspaceIdSummary);
            asLoadingMask.hide();
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-appspace-id/licenseAppspaceId.component.js